import { ColumnElement, ColumnTitle } from '@atoms/columnElement';
import { DateFormatPicker } from '@atoms/dateFormat/dateFormat';
import { Column } from '@components/dnd/base/blockBase/body.block.style';
import { Label } from '@components/ui/label';
import type { AtomModel } from '@models/atom.model';
import type { DateData } from '@stratumn/studio-shared';
import type { PropsWithChildren } from 'react';

type Props = {
  format: DateData['format'];
  onFormatChange: (format: DateData['format']) => void;

  atomId: AtomModel['id'];
};

export const DateWidget = (props: PropsWithChildren<Props>) => (
  <>
    {props.children}

    <Column $width="220px">
      <ColumnTitle>Display options</ColumnTitle>
      <ColumnElement>
        <Label htmlFor={`format-${props.atomId}`}>Date display format</Label>
        <DateFormatPicker
          format={props.format}
          id={`format-${props.atomId}`}
          onFormatChange={props.onFormatChange}
        />
      </ColumnElement>
    </Column>
  </>
);
